<div class="wrapper skeleton">
    <div>
        <div class="skeleton loading-related-records">
            <div class="bone loading-related-records__title"></div>
            <div class="bone loading-related-records__button"></div>
        </div>
    </div>
    <div class="record-field">
        <div class="bone record-field__key"></div>
        <div class="bone record-field__value"></div>
    </div>
    <div class="record-field">
        <div class="bone record-field__key"></div>
        <div class="bone record-field__value"></div>
    </div>
    <div class="record-field">
        <div class="bone record-field__key"></div>
        <div class="bone record-field__value"></div>
    </div>
    <div class="record-field">
        <div class="bone record-field__key"></div>
        <div class="bone record-field__value"></div>
    </div>
    <div class="record-field">
        <div class="bone record-field__key"></div>
        <div class="bone record-field__value"></div>
    </div>
</div>